// Three decimal places are shared by stock, reservations, sales and returns.
export const quantityUnits = value => Math.round(Number(value || 0) * 1000);
export const roundQuantity = value => quantityUnits(value) / 1000;
export const sumQuantities = values => values.reduce((sum,value) => sum + quantityUnits(value),0) / 1000;
export function validMarbleQuantity(value, allowZero = false) {
  if (value === "" || value == null || typeof value === "boolean") return false;
  const number = Number(value);
  return Number.isFinite(number) && number >= (allowZero ? 0 : 0.001) && number <= 999999999999.999 && number === roundQuantity(number);
}
